import { createSlice } from '@reduxjs/toolkit'
import { getObjects, getObject, saveObject, createObject, deleteObject } from './objectActions'

const initialState = {
  objects: [],
  loading: false,
  error: false,
  loadingError: false,
  savingError: false,
  saving: false,
  saved: false,
  savedObject: {},
  deleting: false,
  deleted: false,
  deletingError: false,
}

function isRejectedAction(action) {
  return action.type.endsWith('rejected')
}

const objectsSlice = createSlice({
  name: 'objects',
  initialState,
  reducers: {
    clear: (state) => {
      state.saved = false
      state.savingError = false
      state.loadingError = false
      state.savedObject = {}
      state.deleting = false
      state.deleted = false
      state.deletingError = false
    },
  },

  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder
      .addCase(getObjects.fulfilled, (state, { payload }) => {
        state.loading = false
        state.objects = payload
      })
      .addCase(getObjects.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getObject.fulfilled, (state, { payload }) => {
        if (!state.objects.find((o) => o.id === payload.id)) {
          state.objects.push(payload)
        }
        state.loading = false
        state.error = null
      })
      .addCase(getObject.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(saveObject.pending, (state) => {
        state.saving = true
        state.savingError = null
        state.saved = false
      })
      .addCase(saveObject.fulfilled, (state, { payload }) => {
        state.savingError = null
        state.objects[state.objects.findIndex((p) => p.id === payload.id)] = payload
        state.savedObject = payload
        state.saved = true
        state.saving = false
      })
      .addCase(saveObject.rejected, (state, { payload }) => {
        state.saving = false
        state.savingError = payload
        state.saved = false
      })
      .addCase(createObject.pending, (state) => {
        state.saving = true
        state.savingError = null
        state.saved = false
      })
      .addCase(createObject.fulfilled, (state, { payload }) => {
        state.savingError = null
        state.savedObject = payload
        state.saved = true
        state.saving = false
      })
      .addCase(createObject.rejected, (state, { payload }) => {
        state.saving = false
        state.savingError = payload
        state.saved = false
      })
      .addCase(deleteObject.pending, (state) => {
        state.deleting = true
        state.deletingError = null
        state.deleted = false
      })
      .addCase(deleteObject.fulfilled, (state) => {
        state.deletingError = null
        state.deleted = true
        state.deleting = false
      })
      .addCase(deleteObject.rejected, (state, { payload }) => {
        state.deleting = false
        state.deletingError = payload
        state.deleted = false
      })
      .addMatcher(
        isRejectedAction,
        // `action` will be inferred as a RejectedAction due to isRejectedAction being defined as a type guard
        (state, { payload }) => {
          state.loading = false
          state.error = payload
        },
      )
  },
})

export const { clear } = objectsSlice.actions
export default objectsSlice.reducer
